import React from 'react';
import { projectsData } from '../data/projectsData';

const ProjectsList = ({ img, text, link }) => {
  return (
    <article className="projects-article">
      <a href={link} className="img-a" target="blank">
        <img src={img} className="projects-img" />
      </a>
      <p>{text}</p>
      <a href={link} target="_blank" className="view">
        View
      </a>
    </article>
  );
};

const Projects = () => {
  return (
    <div className="projects-wrapper">
      <div className="title">
        <h2>My Work</h2>
        <div className="line"></div>
      </div>
      <p>Here are a few of my latest projects, I invite you to explore them.</p>
      <aside className="projects-aside">
        {projectsData.map((project) => {
          return <ProjectsList key={project.id} {...project} />;
        })}
      </aside>
    </div>
  );
};

export default Projects;
